// frontend/src/components/ResetPassword.jsx

import React, { useState } from 'react';
import axios from 'axios';
import { useSearchParams, useNavigate } from 'react-router-dom';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const token = searchParams.get('token');

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/api/reset-password', { token, newPassword: password });
      setMessage("Password reset successful! Redirecting to login...");
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      console.error(err);
      setMessage("Something went wrong. Please try again.");
    }
  };

  return (
    <form onSubmit={onSubmit} style={formStyle}>
      <h2>Set New Password</h2>
      <input
        type="password"
        placeholder="Enter new password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        style={inputStyle}
      />
      <button type="submit" style={buttonStyle}>
        Reset Password
      </button>
      {message && <p style={{ marginTop: '12px', color: '#28a745' }}>{message}</p>}
    </form>
  );
}

const formStyle = { maxWidth: 400, margin: '40px auto', padding: 20, border: '1px solid #ddd', borderRadius: 8 };
const inputStyle = { width: '100%', padding: '10px', marginBottom: '12px', fontSize: '16px', borderRadius: 6, border: '1px solid #ccc' };
const buttonStyle = { width: '100%', padding: '12px', fontSize: '16px', backgroundColor: '#00C4CC', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' };
